import { BehaviorSubject, fromEvent, Observable } from 'rxjs';
import { debounceTime } from 'rxjs/internal/operators';
import { Title } from '@angular/platform-browser';
import { leftPad } from './../../utils/util';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "@angular/platform-browser";
export class IdleService {
    constructor(_document, title) {
        this._document = _document;
        this.title = title;
        /**
         * Document Events to watch
         */
        this.dEvents = ['keydown', 'keyup', 'click', 'mousemove', 'DOMMouseScroll', 'mousewheel', 'mousedown',
            'touchstart', 'touchmove', 'scroll', 'focus'];
        /**
         * Document Events subscriptions holder
         */
        this.dEventsSub = [];
        /**
         * Every when should the service check if user been idle, instead of checking every second,
         * check every 5 seconds for example for service to start listening to events. Evenry time the user
         * Interferes, the timers reset and waits for everyWhen seconds to check again.
         * This is config is necessary to avoid performance issues. The higher, the better.
         * default 5 seconds recommended
         */
        this.everyWhen = 5000;
        /**
         * Lockout after limit
         * number | default 2 hours
         */
        this.lockOutLimit = 432000000;
        /**
         * Idle duration after which operations such as
         * a warning or a count down timer can take place
         * number | default 4 minutes
         */
        this.idleDuration = 4; // 4 * 60;
        /**
         * last time user performed one of the events specified
         */
        this.lastActive = new Date();
        /**
         * Ensure events bound once
         */
        this.boundIdleEvents = false;
        /**
         * Prevents multiple execution of timer
         */
        this.pendingReset = false;
        this.lockedOut = new Observable((observer) => {
            this.lockedOutObserver = observer;
            return observer;
        });
        /**
         * Original document title value,
         * Obtained once
         */
        this.titleRef = '';
        /**
         * Set true by user when `I am here` or `Stay logged in` is clicked
         */
        this.userConsentToStay = true;
        /**
         * Signal lockedOut state
         */
        this.disabled = false;
        this.enabled = false;
        /**
         * Fires on IdleService.watch()
         */
        this.onIdelStart = new BehaviorSubject(false);
        /**
         * Fires when time exceeded specified `idleDuration`
         */
        this.beenIdle = new BehaviorSubject(false);
    }
    /**
     * Starts a timer to watch for Idle
     * param args - everyWhen, lockOutLimit
     */
    watch(...args) {
        this.enabled = true;
        /**
         * handle arguments
         * TODO://improve args handling
         */
        // bind events
        if (!this.boundIdleEvents) {
            // const input = this.renderer.selectRootElement(this._document);
            this.dEvents.map(evtName => {
                const s = fromEvent(this._document, evtName)
                    .pipe(debounceTime(500)).subscribe(evt => {
                    if (this.pendingReset) {
                        return false;
                    }
                    this.resetTimers();
                });
                this.dEventsSub.push(s);
                this.boundIdleEvents = true;
            });
        }
        this.onIdelStart.next(true);
        return this;
    }
    /**
     * Responsible of resetting timers as needed
     * and when allowed to reset
     * does not reset if consent is required
     */
    resetTimers() {
        // don't reset if consent is required
        if (!this.userConsentToStay) {
            return;
        }
        this.lastActive = new Date();
        this.pendingReset = true;
        this.clearTimersAndIntervals();
        if (this.titleRef) {
            this.title.setTitle(this.titleRef);
        }
        this.timer = setTimeout(() => {
            /**
             * Dispatch a true value - user been idle for `lockOutLimit` -
             * to Subscribers
             */
            this.lockedOutObserver.next(true);
            // then stop all watch operations
            this.stop();
            // this.disabled = true;
        }, (this.lockOutLimit + this.everyWhen));
        this.timerMgr = setTimeout(() => {
            this.pendingReset = false;
            this.timerStart();
        }, this.everyWhen);
    }
    /**
     * Attempt to stop the watch operations
     */
    stop() {
        try {
            this.dEventsSub.map((debouncedEvt) => debouncedEvt.unsubscribe());
            this.boundIdleEvents = false;
            this.dEventsSub = [];
        }
        catch (e) { }
        this.clearTimersAndIntervals();
        this.expiredTime = new Date();
    }
    /**
     * Clear timers and intervals
     * do each separate
     */
    clearTimersAndIntervals() {
        const timers = [this.timer, this.timerMgr];
        const intervals = [this.titleInterval];
        timers.map(t => {
            try {
                clearTimeout(t);
            }
            catch (e) { }
        });
        intervals.map(iv => {
            try {
                clearInterval(iv);
            }
            catch (e) { }
        });
    }
    /**
     * set limit of lockout by seconds
     * param limit - in seconds
     */
    setTimeout(limit, idleLimit) {
        limit = limit * 1000; // convert to milliseconds
        this.lockOutLimit = limit;
        this.idleDuration = idleLimit || this.idleDuration;
        if (this.enabled) {
            this.resetTimers();
        }
        return this;
    }
    /**
     * Run tasks necessary during watch period
     */
    timerStart() {
        if (this.titleInterval) {
            try {
                clearInterval(this.titleInterval);
            }
            catch (e) { }
        }
        let counter = 0; // counter to ensure request to stay on is prompt once
        this.titleInterval = setInterval(() => {
            if (this.didExceedIdleDuration()) {
                counter++;
                this.updateTitleWithTimer();
                if (counter > 2 && this.userConsentToStay) {
                    this.startTime = new Date();
                    this.userConsentToStay = false;
                    this.beenIdle.next(true);
                    counter = 0;
                }
            }
        }, 1000);
    }
    updateTitleWithTimer() {
        const diff = ((new Date().getTime() - this.lastActive.getTime()) / 1000)
            - (this.everyWhen / 1000); // to seconds
        let remaining = (this.lockOutLimit / 1000) - diff;
        remaining = Math.abs(Math.round(remaining));
        remaining = remaining > 0 ? remaining : 1;
        this.updateTitle(remaining);
    }
    /**
     * Update document title to warn the user of lockOut from other tabs
     */
    updateTitle(time) {
        if (this.startTime) {
            const diff = ((new Date().getTime() - this.startTime.getTime()) / 1000);
            const lockedOut = ((this.lockOutLimit / 1000) - diff) < 0;
            if (lockedOut) {
                this.lockedOutObserver.next(true);
                this.stop();
                return this.title.setTitle(this.titleTimer(1));
            }
        }
        if (!this.titleRef) {
            return this.titleRef = this.title.getTitle();
        }
        this.title.setTitle(this.titleTimer(time));
    }
    /**
     * Compute the remaining into minutes
     */
    titleTimer(remaining) {
        const minutes = Math.floor(remaining / 60);
        const seconds = remaining - minutes * 60;
        return leftPad(minutes, '0', 2) + ':' + leftPad(seconds, '0', 2);
    }
    /**
     * Check time passed the specified IdleDuration limit
     * param idleDuration | from config
     */
    didExceedIdleDuration() {
        const diff = ((new Date().getTime() - this.lastActive.getTime()) / 1000) - (this.everyWhen / 1000);
        return diff > this.idleDuration;
    }
    /**
     * Obtain User cinsent to stay
     */
    requestToStay() {
        this.userConsentToStay = true;
        this.startTime = null;
        this.clearTimersAndIntervals();
        this.lastActive = new Date();
    }
}
IdleService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function IdleService_Factory() { return new IdleService(i0.ɵɵinject(i1.DOCUMENT), i0.ɵɵinject(i2.Title)); }, token: IdleService, providedIn: "root" });
